import { TripPlannerPage } from '@/app/pages/trip-planner/trip-planner-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const tripPlannerSearchSchema = z.object({
  cityId: z.string({ coerce: true }),
  cityName: z.string().optional(),
  regionName: z.string().optional(),
  dateFrom: z.string(),
  dateTo: z.string(),
  adults: z.number(),
  childAges: z.array(z.number()).optional(),
  dayPlan: z.string(),
  travelId: z.string(),
  timeZone: z.string(),
  selectedExcursionId: z.string().optional(),
  excursionDrawer: z.boolean().optional(),
  bookingType: z.enum(['your-tour', 'accommodation', 'excursion']),
  scenarioName: z.string().optional(),
  scenarioSlug: z.string().optional(),
});

export const Route = createFileRoute('/trip-planner/')({
  component: TripPlannerPage,
  validateSearch: tripPlannerSearchSchema,
});
